import React from 'react'
import Head from 'next/head'

export const getJsonLdElement = (
  jsonText?: string
): React.DetailedReactHTMLElement<any, any> | null => {
  if (!jsonText) return null
  const data = JSON.parse(jsonText)
  const json = JSON.stringify(data)

  const interopDefaultLegacy = (e: any): any => {
    return e && typeof e === 'object' && 'default' in e ? e : { default: e }
  }

  const markup = (jsonld: string): { __html: string } => {
    return {
      __html: jsonld,
    }
  }

  const Head__default = /* #__PURE__ */ interopDefaultLegacy(Head)
  const React__default = /* #__PURE__ */ interopDefaultLegacy(React)

  const Element = React.createElement(
    Head__default.default,
    null,
    React__default.default.createElement('script', {
      type: 'application/ld+json',
      dangerouslySetInnerHTML: markup(json),
      key: 'jsonld-dataset',
    })
  )

  return Element
}
